import { render, staticRenderFns } from "./AzSpeech.vue?vue&type=template&id=8703f4ee&"
import script from "./AzSpeech.vue?vue&type=script&lang=js&"
export * from "./AzSpeech.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports